import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, InputNumber } from "antd";
import { createFuel, getFuel } from "../../../API/Admin/fuel";
import { ClipLoader } from "react-spinners";

const Fuel = () => {
  const [regularFuel, setRegularFuel] = useState("");
  const [premiumFuel, setPremiumFuel] = useState("");
  const [lowSulphurDiesel, setLowSulphurDiesel] = useState("");
  const [regularDiesel, setRegularDiesel] = useState("");
  const [id, setId] = useState();
  const [lastUpdated, setLastUpdated] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAllPricesUpdate = async () => {
    try {
      setLoading(true);

      const fuelData = {
        "regular_fuel": parseFloat(regularFuel),
        "premium_fuel": parseFloat(premiumFuel),
        "low_sulphur_diesel": parseFloat(lowSulphurDiesel),
        "regular_diesel": parseFloat(regularDiesel),
      };
      const updated_at =  new Date().toISOString();
      await createFuel(fuelData, updated_at)

      await fetchData(); // Refresh the updated values
      setLoading(false);
    } catch (error) {
      console.error("Error updating fuel prices:", error);
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getFuel();

      setRegularFuel(response?.data?.regular_fuel);
      setPremiumFuel(response?.data?.premium_fuel);
      setLowSulphurDiesel(response?.data?.low_sulphur_diesel);
      setRegularDiesel(response?.data?.regular_diesel);

      setId(response?.data?.id);
      setLastUpdated(response?.data?.data_time);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching fuel data:", error);
      setLoading(false);
    }
  };

  function formatDate(timestamp) {
    const date = new Date(timestamp);

    // Use toLocaleString to format the date and time in a readable format
    const formattedDate = date.toLocaleString("en-US", {
      weekday: "long", // e.g., "Thursday"
      year: "numeric", // e.g., "2024"
      month: "long", // e.g., "November"
      day: "numeric", // e.g., "28"
      hour: "numeric", // e.g., "4"
      minute: "numeric", // e.g., "10"
      second: "numeric", // e.g., "30"
      hour12: true, // Use 12-hour format (optional, set to false for 24-hour format)
    });

    return formattedDate;
  }

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <div className="fuel-admin">
      <div className="page-title">
        <div className="title">Fuel</div>
        <div className="title-description">
          {new Date().toLocaleDateString("en-US", {
            weekday: "long",
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
        </div>
      </div>
      <div className="fuel-container">
        <div className="container-title">Fuel</div>
        <div className="form-items">
          <div className="child">
            <div className="form-title">Regular Diesel (Cost/L)</div>
            <InputNumber
              placeholder="Fuel Price"
              value={regularDiesel}
              onChange={(value) => setRegularDiesel(value)}
            />
          </div>
          <div className="child">
            <div className="form-title">Low Sulphur Diesel (Cost/L)</div>
            <InputNumber
              placeholder="Fuel Price"
              value={lowSulphurDiesel}
              onChange={(value) => setLowSulphurDiesel(value)}
            />
          </div>
          <div className="child">
            <div className="form-title">Regular Fuel (Cost/L)</div>
            <InputNumber
              placeholder="Fuel Price"
              value={regularFuel}
              onChange={(value) => setRegularFuel(value)}
            />
          </div>
          <div className="child">
            <div className="form-title">Premium (Cost/L)</div>
            <InputNumber
              placeholder="Fuel Price"
              value={premiumFuel}
              onChange={(value) => setPremiumFuel(value)}
            />
          </div>
        </div>
      </div>
      <div className="bottom-info">
        <div className="bottom-description">
          Last updated on:{" "}
          {lastUpdated ? formatDate(lastUpdated) : "Not updated yet"}
        </div>

        <div className="update-button">
          <Button onClick={handleAllPricesUpdate}>Update</Button>
        </div>
      </div>
    </div>
  );
};

export default Fuel;
